import {useDispatch, useSelector} from 'react-redux';
import React, {useCallback} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person'
import {toggleModalAction} from 'module/Modal/action/ModalAction';
import {ModalKey} from 'module/Modal/type/ModalKey';
import HomeIcon from '@mui/icons-material/Home'
import {TopNavBarButtonComponent} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import {TopNavBarLeftButtonSection} from 'module/TopNavBar/component/TopNavBarLeftButtonSection';
import {TopNavBarButtonGroup} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonGroup';
import {selNotiShowButton} from 'module/Noti/selector/NotiSelector';
import {NotiButton} from 'module/Noti/component/NotiButton';
import {SwitchBackToDefaultUserButton} from 'module/TopNavBar/component/TopNavBarButton/SwitchBackToDefaultUserButton';
import {selTopNavBarTitle} from 'module/TopNavBar/selector/TopNavBarSelector'
import {selCurrentUserIsAlternative, selCurrentUsernameLong} from 'module/SessionInfo/selector/SessionInfoSelector'
import {useTheme} from '@mui/material'
import {css} from '@emotion/react'

let TOOLBAR_HEIGHT = '40px'

const cssRoot = css`
	flex-grow: 1;
	min-height: ${TOOLBAR_HEIGHT};
	max-height: ${TOOLBAR_HEIGHT};
`
const cssToolbar = css`
	min-height: ${TOOLBAR_HEIGHT};
	max-height: ${TOOLBAR_HEIGHT};
`
const cssTitle = css`
	position: fixed;
	width: 100%;
`
const cssSpacer = css`
	flex-grow: 10;
`
const cssLeft = css`
	flex-grow: 0;
	flex-shrink: 1;
	word-break: break-word;
`

export const TopNavBar = React.memo(() => {
	const theme = useTheme()
	const cssRight = css`
		white-space: pre;
		flex-grow: 0;
		flex-shrink: 1;
		z-index: 1;
		background: ${theme.palette.primary.main};
	`
	const longUsername = useSelector(selCurrentUsernameLong)
	const isAlt = useSelector(selCurrentUserIsAlternative)
	const title = useSelector(selTopNavBarTitle)
	const showNotiButton = useSelector(selNotiShowButton)

	const dispatch = useDispatch();
	const onClickUserButton = useCallback(() => dispatch(toggleModalAction({modalKey: ModalKey.SessionInfo, open: true})), [dispatch]);

	let userButtonStyle;
	if (isAlt) {
		userButtonStyle = {color: '#d6cc3a'}
	}
	return (
		<AppBar position={'fixed'} color={'primary'} css={cssRoot}>
			<Toolbar variant={'dense'} css={cssToolbar}>
				<Typography variant="h6" align={'center'} css={cssTitle}>
					{title}
				</Typography>
				<Typography component={'div'} align={'left'} css={cssLeft}>
					<TopNavBarLeftButtonSection/>
				</Typography>
				<Typography component={'div'} align={'left'} css={cssSpacer}/>
				<Typography component={'div'} align={'right'} css={cssRight}>
					{showNotiButton &&
						<NotiButton/>
					}
					<TopNavBarButtonGroup>
						<TopNavBarButtonComponent href="home.jsp" target="_self">
							<HomeIcon fontSize={'small'}/>
						</TopNavBarButtonComponent>
						<TopNavBarButtonComponent style={userButtonStyle} onClick={onClickUserButton}>
							<PersonIcon fontSize={'small'}/>&nbsp;{longUsername}
						</TopNavBarButtonComponent>
					</TopNavBarButtonGroup>
					{isAlt &&
						<SwitchBackToDefaultUserButton/>
					}
				</Typography>
			</Toolbar>
		</AppBar>
	);
});